import styled from "styled-components";

export const LabelingTitle = styled.div`
  span.press-title-keyword {
    color: var(--keyword-color);
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.012rem;
  }
`;
